import { ethers } from 'ethers';
import ProofOfLifeABI from '../proof-of-life.json';
import { encodeProofPacked } from './proofEncoder';

const CONTRACT_ADDRESS = '0x5d66bec24562493c5a640854e57c535082ee6b50';

export const submitProofOfLife = async (liveData) => {
  if (!window.ethereum) throw new Error('MetaMask não detectada');

  const provider = new ethers.BrowserProvider(window.ethereum);
  const signer = await provider.getSigner();
  const contract = new ethers.Contract(CONTRACT_ADDRESS, ProofOfLifeABI, signer);

  const packedHash = encodeProofPacked(liveData);
  const tx = await contract.submitProof(packedHash);
  await tx.wait();

  return {
    success: true,
    txHash: tx.hash,
    packedHash,
    ruaEarned: 10
  };
};
